export default "__VITE_ASSET__DsqKyODk__"